import { render, staticRenderFns } from "./AddCommunityPayment.vue?vue&type=template&id=1ba752f6"
import script from "./AddCommunityPayment.vue?vue&type=script&lang=js"
export * from "./AddCommunityPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports